/**
 * Click Outside Composable
 * Calls a callback when a click occurs outside the referenced element.
 */
import { onMounted, onUnmounted, type Ref } from 'vue'

export function useClickOutside(
  elementRef: Ref<HTMLElement | null>,
  callback: () => void,
) {
  function handler(event: MouseEvent) {
    if (elementRef.value && !elementRef.value.contains(event.target as Node)) {
      callback()
    }
  }

  onMounted(() => document.addEventListener('click', handler, true))
  onUnmounted(() => document.removeEventListener('click', handler, true))
}
